<template>
	<div
		class="milestone-background"
		:class="`milestone-background-${skin}`"
		:data-event-type="event"
	>
		<svg
			id="Layer_2"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 273 94"
		>
			<defs>
				<linearGradient
					id="milestone-linear-gradient"
					x1="136.5"
					y1="94"
					x2="136.5"
					y2="0"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0"
						:stop-color="skins.get(skin)?.[event].stopColor1"
					/>
					<stop
						offset="1"
						:stop-color="skins.get(skin)?.[event].stopColor2"
					/>
				</linearGradient>
				<linearGradient
					:id="`milestone-linear-gradient-${skin}`"
					x1="136.5"
					y1="94"
					x2="136.5"
					y2="0"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0"
						:stop-color="skins.get(skin)?.[event].stopColor1"
					/>
					<stop
						offset="1"
						:stop-color="skins.get(skin)?.[event].stopColor2"
					/>
				</linearGradient>
			</defs>
			<g id="milestones-treshold-bg-green">
				<polygon
					id="bottom_right"
					class="cls-2"
					points="266.31 47 208.67 90 210 94 273 47 266.31 47"
				/>
				<polygon
					id="top_right"
					class="cls-4"
					points="266.31 47 273 47 210 0 208.67 4 266.31 47"
				/>
				<polygon
					id="bottom_left"
					class="cls-3"
					points="6.69 47 64.33 90 63 94 0 47 6.69 47"
				/>
				<polygon
					id="top_left"
					class="cls-1"
					points="6.69 47 0 47 63 0 64.33 4 6.69 47"
				/>
				<polygon
					id="mid"
					class="cls-5"
					points="266.31 47 208.67 4 64.33 4 6.69 47 64.33 90 64.33 90 208.67 90 208.67 90 266.31 47"
				/>
				<polygon
					id="bottom"
					class="cls-2"
					points="208.67 90 64.33 90 63 94 210 94 208.67 90"
				/>
				<polygon
					id="top"
					class="cls-1"
					points="63 0 64.33 4 208.67 4 210 0 63 0"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts" setup>
import { MilestoneStatus } from "@/types/event";
import { EventCategory } from "@/types/ui";

interface Props {
	skin: MilestoneStatus;
	event: EventCategory;
}

const { skin = MilestoneStatus.LOCKED, event } = defineProps<Props>();

const skins = new Map<
	MilestoneStatus,
	Record<EventCategory, { stopColor1: string; stopColor2: string }>
>([
	[
		MilestoneStatus.CLAIMED,
		{
			[EventCategory.CHRISTMAS]: {
				// TODO spravne farby ked budu
				stopColor1: "#435602",
				stopColor2: "#88af00",
			},
			[EventCategory.EASTER]: {
				stopColor1: "#435602",
				stopColor2: "#88af00",
			},
			[EventCategory.FISHING]: {
				stopColor1: "#435602",
				stopColor2: "#88af00",
			},
			[EventCategory.FIREFEST]: {
				stopColor1: "#435602",
				stopColor2: "#88af00",
			},
			[EventCategory.SOLAR]: {
				stopColor1: "#000",
				stopColor2: "#000",
			},
			[EventCategory.HUNTING]: {
				stopColor1: "#435602",
				stopColor2: "#88af00",
			},
			[EventCategory.HALLOWEEN]: {
				stopColor1: "#025219",
				stopColor2: "#00b333",
			},
			[EventCategory.PIRATES]: {
				stopColor1: "#000",
				stopColor2: "#000",
			},
		},
	],
	[
		MilestoneStatus.CLAIMABLE,

		{
			[EventCategory.CHRISTMAS]: {
				// TODO spravne farby ked budu
				stopColor1: "#4f4a04",
				stopColor2: "#c1b70a",
			},
			[EventCategory.EASTER]: {
				stopColor1: "#4f4a04",
				stopColor2: "#c1b70a",
			},
			[EventCategory.FISHING]: {
				stopColor1: "#4f4a04",
				stopColor2: "#c1b70a",
			},
			[EventCategory.FIREFEST]: {
				stopColor1: "#ce6502",
				stopColor2: "#fdb11e",
			},
			[EventCategory.SOLAR]: {
				stopColor1: "#000",
				stopColor2: "#000",
			},
			[EventCategory.HUNTING]: {
				stopColor1: "#ce6502",
				stopColor2: "#fdb11e",
			},
			[EventCategory.HALLOWEEN]: {
				stopColor1: "#cc5200",
				stopColor2: "#ff972f",
			},
			[EventCategory.PIRATES]: {
				stopColor1: "#000",
				stopColor2: "#000",
			},
		},
	],
	[
		MilestoneStatus.LOCKED,

		{
			[EventCategory.CHRISTMAS]: {
				// TODO spravne farby ked budu
				stopColor1: "#ce6502",
				stopColor2: "#fdb11e",
			},
			[EventCategory.EASTER]: {
				stopColor1: "#ce6502",
				stopColor2: "#fdb11e",
			},
			[EventCategory.FISHING]: {
				stopColor1: "#045877",
				stopColor2: "#009bd3",
			},
			[EventCategory.FIREFEST]: {
				stopColor1: "#932000",
				stopColor2: "#f34416",
			},
			[EventCategory.SOLAR]: {
				stopColor1: "#000",
				stopColor2: "#000",
			},
			[EventCategory.HUNTING]: {
				stopColor1: "#076b0d",
				stopColor2: "#1aaa20",
			},
			[EventCategory.HALLOWEEN]: {
				stopColor1: "#47229e",
				stopColor2: "#7244dd",
			},
			[EventCategory.PIRATES]: {
				stopColor1: "#000",
				stopColor2: "#000",
			},
		},
	],
]);
</script>

<style lang="scss" scoped>
.milestone-background {
	display: flex;
	position: relative;
	z-index: 0;
	width: 100%;
	height: 100%;
	&-claimed {
		.cls-1 {
			fill: #9bbd25;
		}
		.cls-2 {
			fill: #262e03;
		}
		.cls-3 {
			fill: #3d4c03;
		}
		.cls-4 {
			fill: #759501;
		}
		.cls-5 {
			fill: url(#milestone-linear-gradient-claimed);
		}
	}
	&-claimable {
		.cls-1 {
			fill: #cdc42e;
		}
		.cls-2 {
			fill: #aca20c;
		}
		.cls-3 {
			fill: #2f2e1a;
		}
		.cls-4 {
			fill: #474311;
		}
		.cls-5 {
			fill: url(#milestone-linear-gradient-claimable);
		}
	}
	&-locked {
		.cls-1 {
			fill: #4e2903;
		}
		.cls-2 {
			fill: #febe40;
		}
		.cls-3 {
			fill: #874704;
		}
		.cls-4 {
			fill: #cd8613;
		}
		.cls-5 {
			fill: url(#milestone-linear-gradient-locked);
		}
	}
	&[data-event-type="fishing"] {
		&.milestone-background-locked {
			.cls-1 {
				fill: #40b1d9;
			}
			.cls-2 {
				fill: #104356;
			}
			.cls-3 {
				fill: #1a2a30;
			}
			.cls-4 {
				fill: #25abdc;
			}
		}
	}
	&[data-event-type="firefest"] {
		&.milestone-background-locked {
			.cls-1 {
				fill: #de3e13;
			}
			.cls-2 {
				fill: #501201;
			}
		}
	}
	&[data-event-type="hunting"] {
		&.milestone-background-locked {
			.cls-1 {
				fill: #1a8e1f;
			}
			.cls-2 {
				fill: #1a2e1b;
			}
			.cls-3 {
				fill: #4fb655;
			}

			.cls-4 {
				fill: #145117;
			}
		}
	}
	&[data-event-type="halloween"] {
		&.milestone-background-claimed {
			.cls-1 {
				fill: #104b13;
			}

			.cls-2 {
				fill: #192e08;
			}

			.cls-3 {
				fill: #069328;
			}
		}
		&.milestone-background-claimable {
			.cls-1 {
				fill: #d07621;
			}

			.cls-2 {
				fill: #502905;
			}

			.cls-3 {
				fill: #8d450c;
			}
			.cls-4 {
				fill: #fea44c;
			}
		}
		&.milestone-background-locked {
			.cls-1 {
				fill: #8d6cdb;
			}

			.cls-2 {
				fill: #5e3ab3;
			}

			.cls-3 {
				fill: #272039;
			}

			.cls-4 {
				fill: #3d2771;
			}
		}
	}
}
</style>
